var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProduction({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8827 2.89196C18.8827 1.29598 20.1787 0 21.7747 0C23.3707 0 24.6667 1.29598 24.6667 2.89196C24.6667 4.48793 23.3707 5.78391 21.7747 5.78391C20.1787 5.78391 18.8827 4.48793 18.8827 2.89196ZM14.2626 15.3109L17.7306 10.8362L17.6826 10.8602C17.8746 10.5962 17.9106 10.2602 17.7786 9.96021C17.6478 9.66022 17.3586 9.45622 17.0478 9.43222C16.7226 9.39622 16.3998 9.54022 16.2066 9.80421L13.3038 13.5602L9.97859 10.9442C9.77459 10.7882 9.53459 10.727 9.2946 10.7522C9.0558 10.7882 8.8398 10.919 8.6946 11.111L5.14383 15.7321L5.07063 15.8401C4.86663 16.2229 4.96263 16.7149 5.32262 16.9801C5.49062 17.0881 5.67062 17.1601 5.87462 17.1601C6.15182 17.1721 6.41462 17.0269 6.58261 16.8001L9.59459 12.923L13.0146 15.4921L13.1226 15.5629C13.5066 15.7669 13.9866 15.6721 14.2626 15.3109ZM16.8066 2.13633C16.7586 2.43632 16.7346 2.73632 16.7346 3.03631C16.7346 5.73627 18.9186 7.91904 21.6066 7.91904C21.9066 7.91904 22.1946 7.88424 22.4946 7.83624V17.5189C22.4946 21.588 20.0946 24 16.0146 24H7.14781C3.06664 24 0.666656 21.588 0.666656 17.5189V8.64023C0.666656 4.56029 3.06664 2.13633 7.14781 2.13633H16.8066Z",
    fill: "#1676F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduction);
export default __webpack_public_path__ + "static/media/production.1f00a889c4f6e2294aa15188190ee5f4.svg";
export { ForwardRef as ReactComponent };